const formatMsToMinuteSeconds = (ms: number) => {
  const timeRemainingUTCString = new Date(ms).toUTCString()
  const timeRemainingWithHours = timeRemainingUTCString.split(' ').at(4)
  const timeRemaining = timeRemainingWithHours?.slice(3)

  return timeRemaining
}

export { formatMsToMinuteSeconds }
